import { service } from '@ember/service';
import { findRecord } from '@ember-data/legacy-compat/builders';
import AuthenticatedRoute from 'cpc-license-manager/utils/authenticated-route';

export default class LegacyLicenseRoute extends AuthenticatedRoute {
  @service store;

  async model(params) {
    const { content: model } = await this.store.request(findRecord('legacy-license', params.id));
    return model;
  }
}
